import { ChakraProvider } from '@chakra-ui/react'
import store from '@core/app/store/store'
import ApplyV2ErrorBoundary from '@core/components/ApplyDialogV2/ApplyV2ErrorBoundary'
import { IsApplyDialogProvider } from '@core/utils/contexts/ApplyDialogContext/ApplDialogContext'
import { ApplyV2ModalProvider } from '@core/utils/contexts/ApplyV2ModalContext/ApplyV2ModalContext'
import { ModalProvider } from '@core/utils/contexts/ModalContext/ModalContextProvider'
import { ThemeProvider } from '@core/utils/contexts/ThemeContext/ThemeContext'
import '@core/utils/i18n'
import { MantineProvider } from '@mantine/core'

import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import '../../index.css'
import theme from '../../theme.js'
import { PostPage } from './PostPage'
import { PostsPage } from '@page/posts/PostsPage'
import React from 'react'

import { generateRoutes, CustomURL } from '@core/utils/helpers/customeRouteBuilder'

const urls = generateRoutes(':id', '/job/:id')

let routeCollection: object[] = []

urls.forEach((element: CustomURL) => {
    routeCollection.push({
        path: element.url,
        element: (
            <ThemeProvider>
                <IsApplyDialogProvider>
                    <ApplyV2ErrorBoundary>
                        <ApplyV2ModalProvider>
                            <PostPage />
                        </ApplyV2ModalProvider>
                    </ApplyV2ErrorBoundary>
                </IsApplyDialogProvider>
            </ThemeProvider>
        ),
    })
})

const router = createBrowserRouter(routeCollection)

const app = document.getElementById('root')
const root = createRoot(app!)
root.render(
    <>
        <Provider store={store}>
            <ChakraProvider theme={theme}>
                <MantineProvider>
                    <ModalProvider>
                        <RouterProvider router={router} />
                    </ModalProvider>
                </MantineProvider>
            </ChakraProvider>
        </Provider>
    </>
)
